// extracted by mini-css-extract-plugin
export var boldText = "_50-4";
export var checkboxContainer = "_50-6";
export var closeIcon = "_50-i";
export var container = "_50-0";
export var drawer = "_50-8";
export var drawerContent = "_50-9";
export var extraSmallText = "_50-5";
export var fulfillmentGroupTable = "_50-e";
export var largeText = "_50-3";
export var loadingSpinnerContainer = "_50-j";
export var mediumText = "_50-2";
export var narrow = "_50-f";
export var notificationLink = "_50-l";
export var packageCheckIconContainer = "_50-7";
export var slideoutHeaderActions = "_50-g";
export var slideoutHeaderActionsShifted = "_50-h";
export var slideoutHeaderContainer = "_50-a";
export var slideoutModal = "_50-c";
export var stickyHeaderWrapper = "_50-b";
export var table = "_50-k";
export var tableContainer = "_50-d";
export var tertiaryText = "_50-1";